import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { EmojiPlaceholder } from '../EmojiPlaceholder.tsx';

export type EmojiTitleSelectionPlaceholderProps = {
	hasInitialEmoji?: boolean;
	hasCoverPicture?: boolean;
	isTitleCenterAligned?: boolean;
};

// Altogether, the container width should be equivalent to the width of EmojiTitleSelection once loaded
const paddingStyle = xcss({
	paddingRight: 'space.150', // this is the spacing between the emoji button and the title
	paddingLeft: 'space.050', // necessary for left aligning placeholder with emoji button (value comes from from button base)
});

export const EmojiTitleSelectionPlaceholder = ({
	hasInitialEmoji,
	hasCoverPicture,
	isTitleCenterAligned,
}: EmojiTitleSelectionPlaceholderProps): React.JSX.Element | null => {
	const needsPadding = !hasCoverPicture && !isTitleCenterAligned;

	return hasInitialEmoji ? (
		<Box xcss={needsPadding ? paddingStyle : null} testId="emoji-selection-placeholder-container">
			<EmojiPlaceholder height={hasCoverPicture ? 80 : 40} />
		</Box>
	) : null;
};
